export const HOME_RING_RADIUS = 52;
